import { Directive } from '@angular/core';

@Directive({
  selector: '[prizmAccordionTools]',
  standalone: true,
})
export class AccordionToolsDirective {}
